/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { LinqService, QueryOptions } from 'linquest';
import {
  PerformanceFormTemplateBulkUpdateRequestDto,
  PerformanceFormTemplateDetailDto,
  PerformanceFormTemplateDto,
  PerformanceFormTemplateQuery,
  PerformanceFormTemplateTranslatedDto,
  TemplateDetailAndFormDetailDifferenceList,
} from './models';

import { IAjaxProvider } from 'jinqu';

/**
 * PerformanceFormTemplateApi - API class
 */
export class PerformanceFormTemplateApi extends LinqService {

  /**
   * Creates a new PerformanceFormTemplateApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: PerformanceFormTemplateDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param performanceFormTemplateDetailDto 
   */
  addOrUpdateDetailAsync(performanceFormTemplateDetailDto?: PerformanceFormTemplateDetailDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/AddOrUpdateDetailAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = performanceFormTemplateDetailDto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param bulkUpdateRequestDto 
   */
  applyTemplateToExistingForms(bulkUpdateRequestDto?: PerformanceFormTemplateBulkUpdateRequestDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/ApplyTemplateToExistingForms`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = bulkUpdateRequestDto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param performanceFormTemplateDetailId 
   */
  deleteDetailAsync(performanceFormTemplateDetailId?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/DeleteDetailAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'performanceFormTemplateDetailId', value: performanceFormTemplateDetailId && performanceFormTemplateDetailId.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/GetAsync`;
    let query = this.createQuery<PerformanceFormTemplateDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  getPerformanceFormTemplateList(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/GetPerformanceFormTemplateList`;
    let query = this.createQuery<PerformanceFormTemplateQuery>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param bulkUpdateRequestDto 
   */
  getTemplateAndExistingFormDifferences(bulkUpdateRequestDto?: PerformanceFormTemplateBulkUpdateRequestDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/GetTemplateAndExistingFormDifferences`;
    let query = this.createQuery<TemplateDetailAndFormDetailDifferenceList>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = bulkUpdateRequestDto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/GetTranslatedAsync`;
    let query = this.createQuery<PerformanceFormTemplateTranslatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param performanceFormTemplateDetailId 
   */
  isTemplateDetailUsedBefore(performanceFormTemplateDetailId?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/IsTemplateDetailUsedBefore`;
    let query = this.createQuery<boolean>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'performanceFormTemplateDetailId', value: performanceFormTemplateDetailId && performanceFormTemplateDetailId.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param performanceFormTemplateId 
   */
  isUsedBefore(performanceFormTemplateId?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/IsUsedBefore`;
    let query = this.createQuery<boolean>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'performanceFormTemplateId', value: performanceFormTemplateId && performanceFormTemplateId.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param performanceFormTemplateId 
   */
  createNewPerformanceFormTemplateFromCopy(performanceFormTemplateId?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/CreateNewPerformanceFormTemplateFromCopy`;
    let query = this.createQuery<boolean>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'performanceFormTemplateId', value: performanceFormTemplateId && performanceFormTemplateId.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/List`;
    let query = this.createQuery<PerformanceFormTemplateDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/ListTranslated`;
    let query = this.createQuery<PerformanceFormTemplateTranslatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: PerformanceFormTemplateDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  getPerformanceFormBulkApprovalStep(periodId?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplate/GetPerformanceFormBulkApprovalStep`;
    let query = this.createQuery<PerformanceFormTemplateDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'periodId', value: periodId && periodId.toString() });
    query = query.withOptions(options);


    return query;
  }
}
